import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { authApi } from '../../api/client'
import { useAuthStore } from '../../store/authStore'
import GoogleSignInButton from '../../components/auth/GoogleSignInButton'
import toast from 'react-hot-toast'

export default function LoginPage() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const { setTokens, setUser } = useAuthStore()
  const navigate = useNavigate()

  const loginMut = useMutation({
    mutationFn: () => authApi.login(username, password),
    onSuccess: async (res) => {
      setTokens(res.data.access_token, res.data.refresh_token)
      const me = await authApi.me()
      setUser(me.data)
      if (res.data.must_change_password) {
        useAuthStore.getState().setMustChangePassword(true)
        toast('You must change the default password before continuing.', { icon: '🔑' })
        navigate('/change-password')
        return
      }
      toast.success('Welcome back!')
      navigate('/learn')
    },
    onError: (e: any) => toast.error(e.response?.data?.detail || 'Login failed'),
  })

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-baseline gap-1 font-extrabold text-2xl no-underline mb-4">
            <span className="text-brand-blue">PacketFive</span>
            <span className="text-brand-green2">Academy</span>
          </Link>
          <h1 className="text-2xl font-extrabold">Sign in</h1>
          <p className="text-brand-muted text-sm mt-1">Welcome back to PacketFive Academy</p>
        </div>

        {/* Google SSO */}
        <div className="mb-4">
          <GoogleSignInButton />
          <p className="text-brand-muted text-xs text-center mt-2">For registered accounts only. <Link to="/register" className="text-brand-blue">Sign up first</Link>.</p>
        </div>

        {/* Divider */}
        <div className="flex items-center gap-3 mb-4">
          <div className="flex-1 h-px bg-white/10" />
          <span className="text-xs text-brand-muted">or sign in with username</span>
          <div className="flex-1 h-px bg-white/10" />
        </div>

        <form className="card space-y-4" onSubmit={e => { e.preventDefault(); loginMut.mutate() }}>
          <div>
            <label className="label">Username</label>
            <input className="input" type="text" placeholder="your-username" value={username} onChange={e => setUsername(e.target.value)} required autoFocus />
          </div>
          <div>
            <label className="label">Password</label>
            <input className="input" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          <button type="submit" className="btn-primary w-full justify-center" disabled={loginMut.isPending}>
            {loginMut.isPending ? 'Signing in…' : 'Sign in'}
          </button>
          <p className="text-center text-sm text-brand-muted">
            Don't have an account?{' '}
            <Link to="/register" className="text-brand-blue">Create one</Link>
          </p>
        </form>
      </div>
    </div>
  )
}
